import { useEffect, useRef } from 'react';
import { openOfflineDb, closeOfflineDb } from '../lib/offline/offlineDb';

export function useHydration(isLoggedIn: boolean, userId: number | null) {
  const prevUserId = useRef<number | null>(null);

  useEffect(() => {
    if (isLoggedIn && userId) {
      openOfflineDb(userId);
      prevUserId.current = userId;
      // Re-open after a reload: useOfflineStatus' initial refreshPendingCount
      // ran before the Dexie handle was ready and returned 0, leaving the
      // offline badge stuck at 0 until the next mutation (VIVATISPDB-312).
      // Dispatching here lets the badge listener recount against the just-
      // opened DB and show the persisted queue size.
      window.dispatchEvent(new Event('sync-queue-changed'));
    } else if (!isLoggedIn) {
      closeOfflineDb();
      prevUserId.current = null;
    }
  }, [isLoggedIn, userId]);
}
